import { useEffect } from 'react'

import { dispatchErrorToast } from '~/store/slices/toasterSlice'

import { DEFAULT_ERROR_MESSAGE } from './errorMessages'

type ErrorToastOptions = { enabled?: boolean; message?: string }

/**
 * Shows an error toast when a query fails. Accepts a `useQuery` result or a `useQueries` result combined with
 * `combineQueries`. Failed queries are reported to Sentry by `reportQueryError` on the query cache, not here.
 */
export function useErrorToast({ isError }: { isError: boolean }, { enabled = true, message = DEFAULT_ERROR_MESSAGE }: ErrorToastOptions = {}) {
    useEffect(() => {
        if (isError && enabled) {
            dispatchErrorToast({ message })
        }
    }, [isError, enabled, message])
}
